module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAPCAYAAACvMDy4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAOpJREFUeAHd1kEKgkAUgOH3zFa18AgurHVHqJNEEK3rBHWD9mXYDeoGXqF9BB3BRSSF42ueERkWpLZ4+a/GGRA+5oECCMz2yHLc0G8tTh0omAHCYpSpLr5edskwC+MQBPVEUQqDAcZRbz9q7nK8StaNmSr0XlEcWUVuThQsquFEj9Axe5IfJ2oUOdsL7boCn/Qye/r9WIqDcb/AiYRxZXFiYVwZHPKHEASHCDbRO1hy+hHHMIK/DgMCNTgMG9v0rrg/j/yRhWBs2u61n96tAOxeDGrtLM/jx3NlYEmIc2cVTnlpQtUimGkc3AA0RnHMKqTdqQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/package-upgrade/jiantou.png
// module id = h/Yt
// module chunks = 1